<template>
  <div id="app">
    <transition>
      <!-- <keep-alive v-if="$route.meta.keepAlive">
        <router-view ></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" ></router-view> -->
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { getEquipmentType } from "./utils";
import { mapState, mapMutations } from "vuex";
export default {
  name: "App",
  components: {},
  data() {
    return {
      animate: "slide-left",
    };
  },
  watch: {
    $route(to, from) {
    
     
        

    },
  },
  created() {
    this.SET_bowserType(getEquipmentType());
    // 如果ios出现样式问题，用来兼容
    if (this.bowserType === "ios") {
      // require("./assets/css/ios.css");
    }
  },
  computed: {
    ...mapState("forecastBoyAndGirl", {
      bowserType: (state) => {
        window.bowserType = state.bowserType;
        return state.bowserType;
      },
    }),
  },
  methods: {
    ...mapMutations("forecastBoyAndGirl", ["SET_bowserType"]),
  },
};
</script>

<style>
@import "./assets/font/font.css";
@import "./assets/css/animate.min.css";
@import "./assets/css/myAnimate.css";
@import "./assets/css/reset.css";
@import './assets/css/mobile.scss';
@import './assets/css/pc.scss';
input {
  -webkit-user-select: auto; /*webkit浏览器*/
}
#app {
   

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  height: 100%;
  font-size: 14px;
    font-family: OPPO;
    color: #2f3754 !important;
}

</style>
